export interface ValueWrapper<T> {
  value: T;
}

export const extractValue = <T>(x: ValueWrapper<T>) => x.value;
